import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Webcam from "react-webcam";
import { useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import SignatureCanvas from "react-signature-canvas";
import { FILE_BASE_URL } from "./Constatnt";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Select from "react-select";
import {
  UpsertSignAndFieldMap,
  GetUserDataforSeedDistribution,
  GetActiveApprovalSignByOrgCode,
  GetFarmerSignData,
  GetFieldMapImage,
  InsertOrUpdateFieldMapImage,
} from "./Common";

const getRandomColor = () => {
  const colors = [
    "#FFB3BA",
    "#FFDFBA",
    "#FFFFBA",
    "#BAFFC9",
    "#BAE1FF",
    "#E6EEFF",
    "#FFF0F5",
    "#F0FFF0",
    "#E0FFFF",
    "#FFFACD",
    "#F5DEB3",
    "#FFDAB9",
    "#E0BBE4",
    "#D5AAFF",
    "#B5EAD7",
    "#FFDAC1",
    "#C7CEEA",
    "#D3F8E2",
    "#FFCBC1",
    "#E2F0CB",
    "#F1F0C0",
    "#AFCBFF",
    "#FFC9DE",
    "#C9F9FF",
    "#D0F0C0",
    "#FDE2E4",
    "#F9F9C5",
    "#FFE5B4",
    "#D8E2DC",
    "#F0E5CF",
    "#CCE2CB",
    "#F6DFEB",
    "#F3F4ED",
    "#FAF4B7",
    "#D9F8C4",
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

const SignatureThumb = () => {
  const [borderColor, setBorderColor] = useState("");
  const [userData, setUserData] = useState(null);
  const { orgCode, userId } = useParams();
  const [isFingerprintModalOpen, setFingerprintModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [fieldMapPreview, setFieldMapPreview] = useState(false);
  const [fieldMapFile, setFieldMapFile] = useState(null);
  const [options, setOptions] = useState([]);
  const [internalOptions, setInternalOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [farmerSignData, setFarmerSignData] = useState(null);
  const [icsManagers, setIcsManagers] = useState([]);
  const [selectedICSManager, setSelectedICSManager] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const [showModal, setShowModal] = useState(false);
  const [selectedYear, setSelectedYear] = useState(2025);
  const [selectedSeason, setSelectedSeason] = useState("");
 const [selectedOption, setSelectedOption] = useState("fingerprint");
  const [fieldMap, setFieldMap] = useState(null);
  const [penColor, setPenColor] = useState("#0000ff");
  const sigRef = useRef(null);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    Org_Code: orgCode,
    User_ID: userId,
    Signature_Pad: "",
    Signature_Thumb: "",
    Field_Map: "",
    Add_By_User: userId,
    Update_By_User: userId,
    Sign_Approvel_Meneger: "",
    Sign_Internal_Inspectore: "",
    Year: currentYear,
  });

  useEffect(() => {
    setBorderColor(getRandomColor());
  }, []);

  useEffect(() => {
    // API call happens here on every mount/refresh
    const fetchData = async () => {
      try {
        const response = await GetUserDataforSeedDistribution({
          User_ID: userId,
          Org_Code: orgCode,
        });

        setUserData(response.data.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);

  const yearOptions = Array.from({ length: 2050 - 2022 + 1 }, (_, i) => {
    const year = 2022 + i;
    return { value: year, label: year.toString() };
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: false })); // clear error on change
  };

 useEffect(() => {
  const fetchFarmerSignData = async () => {
    try {
      const response = await GetFarmerSignData({
        Org_Code: orgCode,
        User_ID: userId,
      });

      if (response.data?.status && response.data?.data) {
        const data = response.data.data;
        console.log("Farmer Sign API Data:", data);

        // ✅ Prepend FILE_BASE_URL if not a full URL
        const signaturePadUrl = data.Signature_Pad
          ? data.Signature_Pad.startsWith("http")
            ? data.Signature_Pad
            : `${FILE_BASE_URL}${data.Signature_Pad}`
          : "";

        const signatureThumbUrl = data.Signature_Thumb
          ? data.Signature_Thumb.startsWith("http")
            ? data.Signature_Thumb
            : `${FILE_BASE_URL}${data.Signature_Thumb}`
          : "";

        const approvalManagerSignUrl = data.Sign_Approvel_Meneger
          ? data.Sign_Approvel_Meneger.startsWith("http")
            ? data.Sign_Approvel_Meneger
            : `${FILE_BASE_URL}${data.Sign_Approvel_Meneger}`
          : "";

        const internalInspectorSignUrl = data.Sign_Internal_Inspectore
          ? data.Sign_Internal_Inspectore.startsWith("http")
            ? data.Sign_Internal_Inspectore
            : `${FILE_BASE_URL}${data.Sign_Internal_Inspectore}`
          : "";

        // ✅ Remove black background after URL fix
        if (signaturePadUrl) {
          removeBlackBackground(signaturePadUrl).then((whiteImg) => {
            setSignaturePreview(whiteImg);
          });
        }

        if (signatureThumbUrl) {
          removeBlackBackground(signatureThumbUrl).then((whiteImg) => {
            setImageSrc(whiteImg);
          });
        }

        // ✅ Update formData with full URLs
        setFormData((prev) => ({
          ...prev,
          Signature_Pad: signaturePadUrl,
          Signature_Thumb: signatureThumbUrl,
          Sign_Approvel_Meneger: approvalManagerSignUrl,
          Sign_Internal_Inspectore: internalInspectorSignUrl,
        }));

        // ✅ Set previews directly
        if (signaturePadUrl) {
          setSignaturePreview(signaturePadUrl);
        }
        if (signatureThumbUrl) {
          setImageSrc(signatureThumbUrl);
        }
      }
    } catch (error) {
      console.error("Error fetching Farmer Sign Data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (orgCode && userId) {
    fetchFarmerSignData();
  }
}, [orgCode, userId]);


  const removeBlackBackground = (imageUrl) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // Important for cross-domain images
      img.src = imageUrl;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];

          // Detect black background (adjust threshold if needed)
          if (r < 40 && g < 40 && b < 40) {
            data[i] = 255; // Red
            data[i + 1] = 255; // Green
            data[i + 2] = 255; // Blue
          }
        }

        ctx.putImageData(imageData, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
    });
  };

  const handleFingerprintSubmit = async () => {
    if (!imageSrc) {
      Swal.fire({
        title: "No Fingerprint",
        text: "Please scan a fingerprint before submitting.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      // 🔄 Convert BMP base64 to PNG base64
      const pngBase64 = await convertToPngBase64(imageSrc);

      const originalFileName = `fingerprint-${Date.now()}.png`;
      const file = dataURLtoFile(pngBase64, originalFileName); // Real PNG file

      // 📤 Upload file directly without encryption
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        "https://rmsl.geecomindia.in/api/uploadSignSeedDisribution",
        formData,
        {
          headers: {
            Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // Replace this
          },
        }
      );

      const uploadedFileName = response.data.data.filename;

      if (uploadedFileName) {
        const fullUrl = `signSeedDisribution/${uploadedFileName}`;
        setFormData((prev) => ({
          ...prev,
          Signature_Thumb: fullUrl,
        }));
      }

      setFingerprintModalOpen(false);

      Swal.fire({
        title: "Fingerprint Uploaded!",
        text: "Your fingerprint has been uploaded successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(
        "Fingerprint upload failed:",
        error?.response?.data || error.message
      );
      Swal.fire({
        title: "Upload Failed",
        text: error?.response?.data?.message || "Unknown error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const convertToPngBase64 = (bmpBase64Data) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const pngData = canvas.toDataURL("image/png"); // Converts to real PNG
        resolve(pngData);
      };
      img.src = bmpBase64Data;
    });
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";

    // Only allow image/png or jpeg, force it if needed
    const allowedMime = ["image/png", "image/jpeg"];
    const finalMime = allowedMime.includes(mime) ? mime : "image/png";

    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: finalMime });
  };

  const captureFP = () => {
    callSGIFPGetData(successFunc, errorFunc);
  };

  const successFunc = (result) => {
    if (result.ErrorCode === 0) {
      if (result.BMPBase64?.length > 0) {
        setImageSrc("data:image/bmp;base64," + result.BMPBase64);
      }
    } else {
      alert("Fingerprint Capture failed. Error Code: " + result.ErrorCode);
    }
  };

  const errorFunc = () => {
    alert(
      "Fingerprint service not detected!\n\nPlease install and start the SecuGen WebAPI service.\n\nYou will now be redirected to download the setup."
    );
    window.open(
      "https://yourdomain.com/downloads/SGI_BWAPI_S_Win_32bit_1.0.0.41.exe", // Host this on your server
      "_blank"
    );
  };

  const callSGIFPGetData = (successCall, failCall) => {
    const uri = "https://localhost:8000/SGIFPCapture";
    const xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4) {
        if (xmlhttp.status === 200) {
          try {
            const fpObject = JSON.parse(xmlhttp.responseText);
            successCall(fpObject);
          } catch (err) {
            alert("Failed to parse fingerprint response.");
          }
        } else {
          failCall(xmlhttp.status);
        }
      }
    };

    xmlhttp.onerror = function () {
      failCall(xmlhttp.status);
    };

    xmlhttp.open("POST", uri, true);
    xmlhttp.send();
  };

  const toggleModal = () => setIsOpen(!isOpen);

  const clearSignature = () => {
    if (sigRef.current) {
      sigRef.current.clear();
    }
  };

   const handleSignatureSubmit = async () => {
    if (sigRef.current) {
      const dataURL = sigRef.current.toDataURL("image/png");
      setSignaturePreview(dataURL);

      const originalFileName = `signature-${Date.now()}.png`;
      const file = dataURLtoFile(dataURL, originalFileName);

      const formDataObj = new FormData();
      formDataObj.append("file", file);

      try {
        const response = await axios.post(
          "https://rmsl.geecomindia.in/api/uploadSignSeedDisribution",
          formDataObj,
          {
            headers: {
              Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // Replace
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const uploadedFileName = response.data.data.filename;
        if (uploadedFileName) {
          const fullUrl = `signSeedDisribution/${uploadedFileName}`;
          setFormData((prev) => ({
            ...prev,
            Signature_Pad: fullUrl,
          }));
        }

        Swal.fire("Signature Uploaded!", "Your signature has been uploaded successfully.", "success");
      } catch (error) {
        console.error("Upload failed:", error?.response?.data || error.message);
        Swal.fire("Upload Failed", error?.response?.data?.message || "Unknown error occurred.", "error");
      }
    }
  };

    const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formDataObj = new FormData();
    formDataObj.append("file", file);

    try {
      const response = await axios.post(
        "https://rmsl.geecomindia.in/api/uploadSignSeedDisribution",
        formDataObj,
        {
          headers: {
            Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // Replace
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const uploadedFileName = response.data.data.filename;
      if (uploadedFileName) {
        const fullUrl = `signSeedDisribution/${uploadedFileName}`;
        setFormData((prev) => ({
          ...prev,
          Signature_Pad: fullUrl,
        }));
      }

      Swal.fire("Signature Uploaded!", "Your uploaded signature has been saved successfully.", "success");
    } catch (error) {
      console.error("Upload failed:", error?.response?.data || error.message);
      Swal.fire("Upload Failed", error?.response?.data?.message || "Unknown error occurred.", "error");
    }
  };

  const handleFieldMap = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Validate file type
    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!validTypes.includes(file.type)) {
      setFormErrors((prev) => ({
        ...prev,
        Field_Map: "Only JPG, JPEG, or PNG files are allowed.",
      }));
      return;
    }

    // ✅ Show preview
    setFieldMapPreview(URL.createObjectURL(file));
    setFormErrors((prev) => ({ ...prev, Field_Map: "" }));

    try {
      // ✅ Prepare file for upload
      const originalFileName = `fieldmap-${Date.now()}.${file.name
        .split(".")
        .pop()}`;
      const renamedFile = new File([file], originalFileName, {
        type: file.type,
      });

      const formDataObj = new FormData();
      formDataObj.append("file", renamedFile);

      Swal.fire({
        title: "Uploading...",
        text: "Please wait while your field map is uploading.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      // ✅ Upload to server (same as signature)
      const response = await axios.post(
        "https://rmsl.geecomindia.in/api/uploadSignSeedDisribution",
        formDataObj,
        {
          headers: {
            Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // Replace with dynamic token
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.close();

      if (response.status === 200 && response.data?.data?.filename) {
        const uploadedFileName = response.data.data.filename;
        const fullUrl = `signSeedDisribution/${uploadedFileName}`;

        // ✅ Store URL in formData
        setFormData((prev) => ({
          ...prev,
          Field_Map: fullUrl,
        }));
        console.log("fullUrl>>", fullUrl);
        Swal.fire({
          title: "Uploaded!",
          text: "Your field map has been uploaded successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        throw new Error("Unexpected server response");
      }
    } catch (error) {
      console.error("Upload failed:", error?.response?.data || error.message);
      Swal.fire({
        title: "Upload Failed",
        text: error?.response?.data?.message || "Unknown error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleSubmit = async () => {
    const errors = {};

    if (!formData.Field_Map) {
      errors.Field_Map = "Please upload a field map image";
    }
    if (!formData.Sign_Approvel_Meneger) {
      errors.Sign_Approvel_Meneger = "Please select an ICS Manager";
    }
    if (!formData.Sign_Internal_Inspectore) {
      errors.Sign_Internal_Inspectore = "Please select an ICS Manager";
    }
    if (!formData.Season) {
      errors.Season = "Please select a season";
    }

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    try {
      // 1️⃣ Submit to UpsertSignAndFieldMap without Field_Map
      const formDataToSend = new FormData();
      formDataToSend.append("Org_Code", formData.Org_Code);
      formDataToSend.append("User_ID", formData.User_ID);
      formDataToSend.append("Signature_Pad", formData.Signature_Pad);
      formDataToSend.append("Signature_Thumb", formData.Signature_Thumb);
      formDataToSend.append("Add_By_User", formData.Add_By_User);
      formDataToSend.append("Update_By_User", formData.Update_By_User);
      formDataToSend.append(
        "Sign_Approvel_Meneger",
        formData.Sign_Approvel_Meneger
      );
      formDataToSend.append(
        "Sign_Internal_Inspectore",
        formData.Sign_Internal_Inspectore
      );

      const response = await UpsertSignAndFieldMap(formDataToSend);

      const result = response.data;
      if (result.status === 200 || result.status === 201) {
        // 2️⃣ Send Field Map to InsertOrUpdateFieldMapImage
        const seasonId =
          formData.Season === "Rabi"
            ? 1
            : formData.Season === "Kharif"
              ? 2
              : null;

        await InsertOrUpdateFieldMapImage({
          Org_Code: formData.Org_Code,
          Year: formData.Year,
          Season_ID: seasonId,
          User_ID: formData.User_ID,
          Field_Map_Image: formData.Field_Map, // same URL if not changed
        });

        Swal.fire({
          title: "Data Submitted Successfully",
          text: result.message || "Your data has been submitted successfully.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => navigate(`/signature-list/${orgCode}/${selectedYear}/${seasonId}`));
      } else {
        Swal.fire({
          title: "Submission Failed",
          text: result.message || "There was an error submitting your data.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      Swal.fire({
        title: "Network Error",
        text: "Unable to submit data. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    const fetchICSManagers = async () => {
      try {
        const response = await GetActiveApprovalSignByOrgCode({
          Org_Code: orgCode,
          Designation: "1",
        });

        // Assuming API returns an array of objects like:
        // [{ SignID: "manager1", SignName: "Manager 1" }, ...]
        const formattedOptions = response.data.data.map((item) => ({
          value: item.Sign,
          label: item.Person_Name,
        }));

        setOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching ICS Managers:", error);
      }
    };

    if (orgCode) {
      fetchICSManagers();
    }
  }, [orgCode]);

  useEffect(() => {
    const fetchInternalManagers = async () => {
      try {
        const response = await GetActiveApprovalSignByOrgCode({
          Org_Code: orgCode,
          Designation: "2",
        });

        // Assuming API returns an array of objects like:
        // [{ SignID: "manager1", SignName: "Manager 1" }, ...]
        const formattedOptions = response.data.data.map((item) => ({
          value: item.Sign,
          label: item.Person_Name,
        }));

        setInternalOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching ICS Managers:", error);
      }
    };

    if (orgCode) {
      fetchInternalManagers();
    }
  }, [orgCode]);

  useEffect(() => {
  const fetchFieldMapImage = async () => {
    if (!formData.Season || !formData.Year) return;

    const seasonId =
      formData.Season === "Rabi"
        ? 1
        : formData.Season === "Kharif"
        ? 2
        : null;
    if (!seasonId) return;

    try {
      const response = await GetFieldMapImage({
        Org_Code: formData.Org_Code,
        Year: formData.Year,
        Season_ID: seasonId,
        User_ID: userId,
      });

      const imagePath = response?.data?.data?.Field_Map_Image || "";
      const fullImageUrl = imagePath ? `${FILE_BASE_URL}${imagePath}` : "";

      if (fullImageUrl) {
        setFieldMapPreview(fullImageUrl);
        setFormData((prev) => ({
          ...prev,
          Field_Map: fullImageUrl,
        }));
      } else {
        setFieldMapPreview("");
        setFormData((prev) => ({
          ...prev,
          Field_Map: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching Field Map image:", error);
    }
  };

  fetchFieldMapImage();
}, [formData.Season, formData.Year]);


  const handleICSManager = (selected) => {
    setFormData((prev) => ({
      ...prev,
      Sign_Approvel_Meneger: selected?.value || "",
    }));
  };

  const handleInspectionManager = (selected) => {
    setFormData((prev) => ({
      ...prev,
      Sign_Internal_Inspectore: selected?.value || "",
    }));
  };

  const handleNavigate = () => {
    if (!selectedSeason) {
      Swal.fire("Please select a season", "", "warning");
      return;
    }

    const seasonId =
      selectedSeason === "Rabi" ? 1 : selectedSeason === "Kharif" ? 2 : null;
    navigate(`/signature-list/${orgCode}/${selectedYear}/${seasonId}`);
  };

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-6">
      <div
        className="border-t border-l border-r border-b-0 rounded-t shadow bg-white p-4"
        style={{
          borderTopColor: borderColor,
          borderTopWidth: "4px",
          borderTopStyle: "solid",
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b pb-2 mb-4">
          <h2 className="text-2xl font-bold text-green-600">Seed Detail</h2>
          <button
            className="px-8 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            onClick={() => setShowModal(true)}
          >
            List
          </button>
        </div>

        {/* Farmer Details */}
        <div
          className="max-w-xl mx-auto mt-10 mb-6 p-6 bg-white border-t-4 rounded-2xl text-gray-800 text-base shadow"
          style={{ borderTopColor: borderColor }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6">
            <div className="text-base">
              <span className="font-semibold text-gray-600">Name:</span>{" "}
              {userData?.user?.User_Name?.replace(/"/g, "") || "NA"}
            </div>
            <div className="text-base">
              <span className="font-semibold text-gray-600">Father Name:</span>{" "}
              {userData?.responses?.FatherName?.replace(/"/g, "") || "NA"}
            </div>
            <div className="text-base">
              <span className="font-semibold text-gray-600">Village:</span>{" "}
              {userData?.responses?.Village?.replace(/"/g, "") || "NA"}
            </div>
            <div className="text-base">
              <span className="font-semibold text-gray-600">Area:</span>{" "}
              {userData?.responses?.Area?.replace(/"/g, "") || "NA"}
            </div>
          </div>
        </div>

       <div
  className="shadow p-3 rounded border-t-4 mb-4"
  style={{ borderTopColor: borderColor }}
>
  <label className="block font-semibold text-black mb-3">
    Signature Type
  </label>
  <div className="flex flex-col gap-3">
    <label className="flex items-center gap-2">
      <input
        type="radio"
        value="fingerprint"
        checked={selectedOption === "fingerprint"}
        onChange={(e) => setSelectedOption(e.target.value)}
        className="cursor-pointer"
      />
      Scan Fingerprint
    </label>

    <label className="flex items-center gap-2">
      <input
        type="radio"
        value="draw"
        checked={selectedOption === "draw"}
        onChange={(e) => setSelectedOption(e.target.value)}
        className="cursor-pointer"
      />
      Draw Signature
    </label>

    <label className="flex items-center gap-2">
      <input
        type="radio"
        value="upload"
        checked={selectedOption === "upload"}
        onChange={(e) => setSelectedOption(e.target.value)}
        className="cursor-pointer"
      />
      Upload Signature
    </label>
  </div>
</div>


        {/* Fingerprint Section */}
        {/* Fingerprint Section */}
       {/* Fingerprint Section */}
{selectedOption === "fingerprint" && (
        <div className="shadow p-3 rounded border-t-4 mb-4" style={{ borderTopColor: borderColor }}>
          <label className="block font-semibold text-black mb-2">Scan Fingerprint</label>
          <button
            type="button"
            onClick={() => setFingerprintModalOpen(true)}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            🌟 Click to Scan Fingerprint
          </button>

          {(imageSrc || formData.Signature_Thumb) && (
            <>
              <h3 className="mt-4">Scanned Image:</h3>
              <img
                src={
                  imageSrc ||
                  (formData.Signature_Thumb?.startsWith("http")
                    ? formData.Signature_Thumb
                    : `${FILE_BASE_URL}${formData.Signature_Thumb}`)
                }
                alt="Fingerprint"
                style={{
                  border: "1px solid #ccc",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </>
          )}
        </div>
      )}

      {/* Draw Signature */}
      {selectedOption === "draw" && (
        <div className="shadow p-3 rounded border-t-4 mb-4" style={{ borderTopColor: borderColor }}>
          <label className="block font-semibold text-black mb-2">Digital Signature</label>
          <button
            type="button"
            onClick={toggleModal}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            ✍️ Draw Signature
          </button>

          {(signaturePreview || formData.Signature_Pad) && (
            <div className="mt-4">
              <h3 className="text-lg font-medium mb-2">Signature Preview:</h3>
              <img
                src={
                  signaturePreview ||
                  (formData.Signature_Pad?.startsWith("http")
                    ? formData.Signature_Pad
                    : `${FILE_BASE_URL}${formData.Signature_Pad}`)
                }
                alt="Digital Signature"
                style={{
                  border: "1px solid #ccc",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>
          )}
        </div>
      )}

      {/* Upload Signature */}
      {selectedOption === "upload" && (
        <div className="shadow p-3 rounded border-t-4 mb-4" style={{ borderTopColor: borderColor }}>
          <label className="block font-semibold text-black mb-2">Upload Signature</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileUpload}
            className="mb-3"
          />

          {formData.Signature_Pad && (
            <div className="mt-4">
              <h3 className="text-lg font-medium mb-2">Uploaded Signature Preview:</h3>
              <img
                src={
                  formData.Signature_Pad?.startsWith("http")
                    ? formData.Signature_Pad
                    : `${FILE_BASE_URL}${formData.Signature_Pad}`
                }
                alt="Uploaded Signature"
                style={{
                  border: "1px solid #ccc",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>
          )}
        </div>
      )}



        <div className="flex gap-4 mb-4">
          {/* Year Field */}
          <div className="flex-1">
            <label className="block font-semibold text-black mb-1">
              Year<span className="text-red-600">*</span>
            </label>
            <Select
              value={
                yearOptions.find((opt) => opt.value === formData.Year) || null
              }
              onChange={(selectedOption) =>
                handleChange("Year", selectedOption?.value || "")
              }
              options={yearOptions}
              placeholder="Select Year"
              isSearchable
              classNamePrefix={
                formErrors.Year ? "react-select-error" : "react-select"
              }
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderRadius: "0.5rem",
                  padding: "2px",
                  borderColor: formErrors.Year ? "#f87171" : "#d1d5db",
                  boxShadow: state.isFocused
                    ? `0 0 0 2px ${formErrors.Year ? "#f87171" : "#4ade80"}`
                    : undefined,
                  "&:hover": {
                    borderColor: formErrors.Year ? "#f87171" : "#4ade80",
                  },
                }),
              }}
            />
            {formErrors.Year && (
              <p className="text-red-500 text-sm">{formErrors.Year}</p>
            )}
          </div>

          {/* Season Field */}
          <div className="flex-1">
            <label className="block font-semibold text-black mb-1">
              Season<span className="text-red-600">*</span>
            </label>
            <select
              className={`w-full border p-2 rounded transition-colors duration-200 ${formErrors.Season ? "border-red-500" : "border-gray-300"
                } hover:border-green-400 focus:outline-none focus:ring-2 focus:ring-green-400`}
              value={formData.Season}
              onChange={(e) => {
                const value = e.target.value;
                handleChange("Season", value);
              }}
            >
              <option value="">Select Season</option>
              <option value="Rabi">Rabi</option>
              <option value="Kharif">Kharif</option>
            </select>

            {formErrors.Season && (
              <p className="text-red-500 text-sm">{formErrors.Season}</p>
            )}
          </div>
        </div>

        {/* Field Map Section */}
        <div
          className="shadow p-3 rounded border-t-4 mb-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-2">
            Field Map Image
          </label>

          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={handleFieldMap}
            className="block w-full text-sm text-gray-700 border rounded p-2 cursor-pointer"
          />

          {formErrors.Field_Map && (
            <p className="text-red-500 text-sm">{formErrors.Field_Map}</p>
          )}

          {formData?.Field_Map ? (
            <div className="mt-4">
    <a
      href={formData.Field_Map}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 hover:underline mt-2 block"
    >
      View Uploaded Image
    </a>
  </div>
          ) : null}
        </div>

        {/* ICS Manager Section */}
        <div
          className="shadow p-3 rounded border-t-4 mb-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-2">
            Appvroval Manager
          </label>
          <Select
            options={options}
            onChange={handleICSManager}
            value={
              options.find(
                (opt) => opt.value === formData.Sign_Approvel_Meneger
              ) || null
            }
            className="text-sm"
            placeholder="Select ICS Manager"
            isLoading={!options.length}
          />
          {formErrors.Sign_Approvel_Meneger && (
            <p className="text-red-500 text-xs mt-1">
              {formErrors.Sign_Approvel_Meneger}
            </p>
          )}
        </div>

        {/* ICS Manager Section */}
        <div
          className="shadow p-3 rounded border-t-4 mb-4"
          style={{ borderTopColor: borderColor }}
        >
          <label className="block font-semibold text-black mb-2">
            Internal Inspector
          </label>
          <Select
            options={internalOptions}
            onChange={handleInspectionManager}
            value={
              internalOptions.find(
                (opt) => opt.value === formData.Sign_Internal_Inspectore
              ) || null
            }
            className="text-sm"
            placeholder="Select Internal Inspector "
            isLoading={!internalOptions.length}
          />

          {formErrors.Sign_Internal_Inspectore && (
            <p className="text-red-500 text-xs mt-1">
              {formErrors.Sign_Internal_Inspectore}
            </p>
          )}
        </div>

        {/* Fingerprint Modal */}
        {isFingerprintModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative bg-white p-6 rounded-lg shadow-2xl w-full max-w-2xl">
              <button
                className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
                onClick={() => setFingerprintModalOpen(false)}
                aria-label="Close"
              >
                &times;
              </button>
              <h2 className="text-2xl font-semibold mb-4 text-center">
                Scan Fingerprint
              </h2>
              <div className="flex flex-col items-center gap-4">
                <button
                  onClick={captureFP}
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  🖐 Start Fingerprint Scan
                </button>
                {formErrors.Signature_Thumb && (
                  <p className="text-red-500 text-sm">
                    {formErrors.Signature_Thumb}
                  </p>
                )}
                {(imageSrc || formData.Signature_Thumb) && (
                  <div className="text-center">
                    <h3 className="text-lg font-medium mb-2">Scanned Image:</h3>
                    <img
                      src={imageSrc || formData.Signature_Thumb}
                      alt="Fingerprint"
                      height="300"
                      width="210"
                      style={{ border: "2px solid black" }}
                    />
                  </div>
                )}
                <div className="flex gap-4 mt-4">
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                    onClick={() => {
                      setImageSrc(null);
                    }}
                  >
                    Clear
                  </button>
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    onClick={handleFingerprintSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Signature Modal */}
        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative bg-white p-6 rounded-lg shadow-2xl w-full max-w-2xl">
              <button
                className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
                onClick={toggleModal}
                aria-label="Close"
              >
                &times;
              </button>
              <h2 className="text-2xl font-semibold mb-4 text-center">
                Add Signature
              </h2>
              <SignatureCanvas
                penColor={penColor}
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: "border border-gray-300 rounded-md w-full",
                }}
                ref={sigRef}
              />
              <div className="mt-4 flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center space-x-3">
                  <label className="font-medium">Pen Color:</label>
                  <input
                    type="color"
                    value={penColor}
                    onChange={(e) => setPenColor(e.target.value)}
                    className="border rounded w-10 h-10 p-1"
                  />
                </div>
                <div className="flex space-x-3">
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
                    onClick={clearSignature}
                  >
                    Clear
                  </button>
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    onClick={handleSignatureSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
              <h2 className="text-lg font-semibold mb-4">
                Select Year & Season
              </h2>

              {/* Year dropdown */}
              <label className="block mb-2 font-medium">Year</label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                className="w-full border p-2 rounded mb-4"
              >
                <option value={2023}>2023</option>
                <option value={2024}>2024</option>
                <option value={2025}>2025</option>
              </select>

              {/* Season dropdown */}
              <label className="block mb-2 font-medium">Season</label>
              <select
                value={selectedSeason}
                onChange={(e) => setSelectedSeason(e.target.value)}
                className="w-full border p-2 rounded mb-4"
              >
                <option value="">Select Season</option>
                <option value="Rabi">Rabi</option>
                <option value="Kharif">Kharif</option>
              </select>

              {/* Actions */}
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setShowModal(false);
                    handleNavigate();
                  }}
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Submit Button */}
        <div className="text-right">
          <button
            onClick={handleSubmit}
            className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignatureThumb;
